import { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../../../../hooks/useAuth';
import { useEnv } from '../../../../context/env-context';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import { makeRequest } from '../../../../utils/makeRequest';

function ReportsSurveysModalForm({ close, setSpinner, createReport }) {
  const { apiOriginConsumer } = useEnv();
  const { getAccessTokenSilently } = useAuth();

  const [surveyTypes, setSurveyTypes] = useState([]);
  const [selectedType, setSelectedType] = useState('');

  const getSurveyTypes = async () => {
    const token = await getAccessTokenSilently();

    if (!token) {
      return;
    }

    setSpinner(true);
    const config = {
      token,
      url: `${apiOriginConsumer}/rewards/types`,
      method: 'GET',
      params: { category: 'SURVEY' },
    };

    try {
      const response = await makeRequest(config);

      setSurveyTypes(response);
    } catch (error) {
      toast.error(`Failed getting survey types: ${error.message}`);
    } finally {
      setSpinner(false);
    }
  };

  useEffect(() => {
    getSurveyTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleCreate = () => createReport({ type: selectedType });

  return (
    <>
      <div>
        <Row className="align-items-center">
          <Col md={4} className="bo-same-line">
            <Form.Label>Survey:</Form.Label>
          </Col>
          <Col md={8} className="bo-same-line">
            <Form.Select
              className="bo-filter bo-w-250"
              value={selectedType}
              onChange={e => setSelectedType(e.target.value)}
            >
              <option value="">Select...</option>
              {surveyTypes.map(survey => (
                <option key={survey.type} value={survey.type}>
                  {survey.name.en}
                </option>
              ))}
            </Form.Select>
          </Col>
        </Row>
      </div>
      <Row className="mt-auto">
        <Col className="d-flex justify-content-center gap-3">
          <Button className="bo-button" onClick={handleCreate} disabled={!selectedType}>
            Create
          </Button>
          <Button className="bo-button" onClick={close}>
            Cancel
          </Button>
        </Col>
      </Row>
    </>
  );
}

export default ReportsSurveysModalForm;
